var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',{staticClass:"s-slice",class:_vm.className,attrs:{"id":_vm.id}},[_c('div',{staticClass:"a-container"},[(_vm.title || _vm.lead || _vm.bodyText)?_c('a-slice-header',{attrs:{"title":_vm.title,"lead":_vm.lead,"body-text":_vm.bodyText}}):_vm._e(),_vm._v(" "),_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }